/**
 * A regra de "é gestor do escritório" do módulo, em UM lugar — reusada pela
 * tela de Configurações (habilita a edição das premissas, spec-017 [US-3]) e
 * pelo shell do nav-bar (esconde a aba "Configurações" pra quem não pode
 * mexer em nada nela, 05/08/2026, pedido do CTO).
 *
 * `user` é o retorno de `$currentUser()`, resolvido no `created()` de quem
 * chama — NÃO num computed. Não é por falta de reatividade: `$currentUser()`
 * (`src/main.js`) é `store.getters['user/currentUser']`, um getter Vuex, e
 * LÊ-lo dentro de um computed reavalia normalmente (ver `isGestor()` em
 * `view-fee-fixo-dashboard.vue`/`view-fee-fixo-clientes.vue`, que já fazem
 * isso em produção). É `created()` porque o guard global do router já faz
 * `await P.getCurrentUser()` antes de qualquer navegação — o usuário está
 * carregado a tempo do `created()` do shell, então resolver ali é simples e
 * suficiente; não há necessidade real de um computed aqui.
 *
 * Não gateia o BACKEND — quem barra a escrita das premissas é
 * `aawz_fee_fixo` (`status: 403` no corpo). ★ 06/08/2026: a ROTA
 * `fee-fixo.configuracoes` é gestor-only (`customPermission` em
 * `routes.js:148`) — deep-link vira 404 pra não-gestor. Isto aqui (`ehGestor`)
 * é a metade de UX: some o convite de uma tela que, pra quem não é gestor,
 * nem chega a abrir.
 */
export function usuarioEhGestor(user) {
  return Boolean(user && user.IS_GESTOR)
}

/**
 * As duas visões da carteira do módulo — os mesmos valores do toggle da aba
 * Clientes (`VIEW_MODE_OPTIONS`) e do query param de `/clientes` e
 * `/guia/estado`. Declaradas aqui, ao lado da regra que escolhe entre elas;
 * `apiFeeFixoGuia` as re-exporta para quem já as importava de lá.
 */
export const VISAO_PROFISSIONAL = 'profissional'
export const VISAO_ESCRITORIO = 'escritorio'

/**
 * A visão em que este usuário enxerga a carteira — a MESMA que a IA lê.
 *
 * As tools do especialista recebem `gestor` da sessão e o usecase da listagem
 * aplica os dois eixos de tenant (`id_escritorio` + `id_profissional`/`gestor`):
 * para quem é gestor, o recorte que a IA sugere e o estado que ela mede valem
 * sobre o ESCRITÓRIO. Quem promove alguém à visão ampla é o backend; isto só
 * evita pedir (e recortar) a visão errada.
 *
 * Existe como função porque os dois consumidores já divergiram na prática: a
 * entrada do guia pedia o estado na visão de escritório e a aba Clientes
 * aplicava o recorte dela sobre Minha Carteira — 62 clientes viravam "nenhum
 * cliente atende aos filtros" (G-Q2, medido pelo QA em 23/08/2026).
 *
 * @param {?Object} user Retorno de `$currentUser()`.
 * @returns {string} `escritorio` para gestor, `profissional` para o resto.
 */
export function visaoDaCarteira(user) {
  return usuarioEhGestor(user) ? VISAO_ESCRITORIO : VISAO_PROFISSIONAL
}
